


































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetExeImg, UploadFile } from "@/request/common";
import Empty from "@/components/empty.vue";
import PreviewImg from "./preview-dialog.vue";
import PreviewVideo from "./preview-video.vue";
import TakePhotosWhitelight from "./take-photos_whitelight.vue";
import TakeTongueThree from "./take-tongue-three.vue";
import TakePalmTwo from "./take-palm-two.vue";

import ShootVideos from "./shoot-videos.vue";
@Component({
  components: {
    Empty,
    PreviewVideo,
    PreviewImg,

    TakePhotosWhitelight,
    TakeTongueThree,
    TakePalmTwo,

    ShootVideos,
  },
})
export default class Name extends Vue {
  @Prop()
  private content: any; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    if (this.content) {
      this.cContent = JSON.parse(JSON.stringify(this.content));
    }
  }
  @Prop()
  private index: any; // 当前题目的索引
  @Prop()
  private data: any; // 题目的数据
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.c = JSON.parse(JSON.stringify(this.data));
    }
  }
  private templateIndex: any = null;
  private c: any = {};
  private imgs: any = [];
  private cContent: any = {}; // 因为不能直接改动prop里面的数据，所以用Ccontent暂存下
  private uid: any = ""; // 打开exe时生成的id
  private ifShowTakePhotos270: any = false;
  private ifShowShootVideos: any = false;
  private ifShowPreview: any = false;
  private ifShowPreviewVideo: any = false;
  private ifShowTakePhotosWhitelight: any = false;
  private ifShowTakeTongueThree: any = false;
  private ifShowTakePalmTwo: any = false;
  private previewUrl: any = "";
  private get patient() {
    return this.$store.state.patient;
  }
  private delImg(index: any) {
    this.imgs.splice(index, 1);
    this.$forceUpdate();
  }
  private preview(url: any) {
    // window.open(url);
    this.ifShowPreview = true;
    this.previewUrl = url;
  }
  private previewVideo(url: any) {
    this.ifShowPreviewVideo = true;
    this.previewUrl = url;
  }
  private closePreview() {
    this.ifShowPreview = false;
    this.ifShowPreviewVideo = false;
  }
  /**
   * @description 打开拍照
   */
  private startTakePhotos270() {
    this.ifShowTakePhotos270 = true;
  }
  private startTakePhotosWhitelight() {
    this.ifShowTakePhotosWhitelight = true;
  }
  private startTakeTongueThree() {
    this.ifShowTakeTongueThree = true;
  }
  private startTakePalmTwo() {
    this.ifShowTakePalmTwo = true;
  }
  // 上传视频
  /**
   * @description 上传视频
   */
  private uploadVideo(d: any) {
    if (!this.c.value.videos) {
      this.c.value.videos = [];
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    UploadFile(this, form, loading).then((data: any) => {
      this.c.value.videos.push(data.data);
      this.$forceUpdate();
      this.$emit("update", this.c);
    });
  }
  private addImg() {
    console.log('删除');
    this.$emit("updateImg", this.imgs);
  }

  /**
   * @description 上传图片
   */
  private upload(d: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    UploadFile(this, form, loading).then((data: any) => {
      this.$forceUpdate();
      this.imgs.push(data.full_file_url);
    });
  }
  // USB 三连拍
  private takeUSBPhoneSure(val: any) {
    // if (!this.c.value.imgs) {
    //   this.c.value.imgs = [];
    // }
    // this.c.value.imgs = val;
    // this.$forceUpdate();
    // this.$emit("update", this.c);
    this.imgs = this.imgs.concat(val);
    this.ifShowTakeTongueThree = false;
    this.ifShowTakePalmTwo = false;
  }
  // USB 拍摄视频
  /**
   * @description 打开USB拍视频
   */
  private startShootVideos() {
    this.ifShowShootVideos = true;
  }
  private shootVideosSure(val: any) {
    if (!this.c.value.videos) {
      this.c.value.videos = [];
    }
    this.c.value.videos.push(val);
    this.$forceUpdate();
    this.$emit("update", this.c);
    this.ifShowShootVideos = false;
  }
  private GoDevices() {
    console.log(this.c);
    if (
      this.c.type == "舌象" ||
      this.c.type == "舌底" ||
      this.c.type == "舌象80"
    ) {
      this.GoSheDevices();
    } else if (this.c.type == "面象" || this.c.type == "面象15") {
      this.GoMianDevices();
    } else if (this.c.type == "脉象") {
      this.GoMaiDevices();
    }
  }

  // 调取面象设备拍摄,这里拍摄完成后会直接调取保存接口
  private GoMianDevices() {
    this.uid = Date.now() + "_" + this.patient.id;
    window.electronMyAPI.launchExe("face", this.uid);
    // 弹出中间弹框
    this.$confirm("面象照片采集完成!", "面象采集", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      confirmButtonText: "查看报告",
      showCancelButton: false,
    }).then(() => {
      // 先获取图片填充到value，然后保存content
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          uid: this.uid,
          name: "face",
        },
      };
      GetExeImg(this, params, loading).then((res: any) => {
        loading.close();
        if (res.code == 2000) {
          // 修改value
          let d: any = JSON.parse(JSON.stringify(this.c));
          d.value.imgs = [res.data];
          this.$forceUpdate();
          this.$emit("update", d);
          // 保存
          this.$emit("save");
        } else {
          this.$confirm("对不起，报告查看失败，请重新拍摄！", "查看报告", {
            customClass: "commonConfirm",
            confirmButtonClass: "iconfont icon-anniu4 confirmSure",
            cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
            confirmButtonText: "重新拍摄",
            cancelButtonText: "返回",
          })
            .then(() => {
              this.GoMianDevices();
            })
            .catch(() => {
              this.$store.commit("updateIfCompose", false);
              if (this.$store.state.defaultPage) {
                this.$router.push(this.$store.state.defaultPage);
              } else {
                this.$router.push("/main/manage/folder");
              }
            });
        }
      });
    });
  }

  // 调取脉象设备拍摄,这里拍摄完成后会直接调取保存接口
  private GoMaiDevices() {
    this.uid = Date.now() + "_" + this.patient.id;
    window.electronMyAPI.launchExe("pulse", this.uid);
    // 弹出中间弹框
    this.$confirm("脉象数据", "脉象采集", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      confirmButtonText: "查看报告",
      showCancelButton: false,
    }).then(async () => {
      // 上传脉
      const res = await window.electronMyAPI.uploadPulse(this.uid);

      // 先获取图片填充到value，然后保存content
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          uid: res,
          name: "pulse",
        },
      };
      GetExeImg(this, params, loading).then((res: any) => {
        loading.close();
        if (res.code == 2000) {
          // 修改value
          this.cContent.data[this.templateIndex].value = res.data.imgs;
          // 修改report
          this.cContent.report = res.data.report;
          this.$forceUpdate();
          this.$emit("updateContent", this.cContent);
          // 保存
          this.$emit("save");
        } else {
          this.$confirm("对不起，报告查看失败，请重新采集！", "查看报告", {
            customClass: "commonConfirm",
            confirmButtonClass: "iconfont icon-anniu4 confirmSure",
            cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
            confirmButtonText: "重新采集",
            cancelButtonText: "返回",
          })
            .then(() => {
              this.GoMaiDevices();
            })
            .catch(() => {
              this.$store.commit("updateIfCompose", false);
              if (this.$store.state.defaultPage) {
                this.$router.push(this.$store.state.defaultPage);
              } else {
                this.$router.push("/main/manage/folder");
              }
            });
        }
      });
    });
  }
  // 拍照功能
  private takePhoneNormalSure(val: any) {
    // if (!this.c.value) {
    //   this.c.value = {};
    // }
    // if (!this.c.value.imgs) {
    //   this.c.value.imgs = [];
    // }
    // this.c.value.imgs = this.c.value.imgs.concat(val);
    // this.$forceUpdate();
    // this.$emit("update", this.c);
    // this.addImg();
    this.imgs = this.imgs.concat(val);
    this.ifShowTakePhotosWhitelight = false;
  }
  // 调取舌象设备拍摄,这里拍摄完成后会直接调取保存接口
  private GoSheDevices() {
    this.uid = Date.now() + "_" + this.patient.id;
    window.electronMyAPI.launchExe("tongue", this.uid);
    // 弹出中间弹框
    this.$confirm("舌象照片采集完成!", "舌象采集", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      confirmButtonText: "查看报告",
      showCancelButton: false,
    }).then(() => {
      // 先获取图片填充到value，然后保存content
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          uid: this.uid,
          name: "tongue",
        },
      };
      GetExeImg(this, params, loading).then((res: any) => {
        loading.close();
        if (res.code == 2000) {
          let d: any = JSON.parse(JSON.stringify(this.c));
          d.value.imgs = [res.data];
          this.$forceUpdate();
          this.$emit("update", d);
          // 保存
          this.$emit("save");
        } else {
          this.$confirm("对不起，报告查看失败，请重新拍摄！", "查看报告", {
            customClass: "commonConfirm",
            confirmButtonClass: "iconfont icon-anniu4 confirmSure",
            cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
            confirmButtonText: "重新拍摄",
            cancelButtonText: "返回",
          })
            .then(() => {
              this.GoSheDevices();
            })
            .catch(() => {
              this.$store.commit("updateIfCompose", false);
              if (this.$store.state.defaultPage) {
                this.$router.push(this.$store.state.defaultPage);
              } else {
                this.$router.push("/main/manage/folder");
              }
            });
        }
      });
    });
  }
}
